import { forwardRef } from 'react';

import { useTheme } from '@gogame/ui/styles';

export const Text = forwardRef(
  ({ children, visibleTicksCount, verticalAnchor, ...props }, ref) => {
    // we skip props: visibleTicksCount, verticalAnchor because <text> does not use it.
    const theme = useTheme();
    return (
      <text fontSize={'11px'} {...props} ref={ref}>
        <tspan fontFamily={theme.typography.fontFamily}>{children}</tspan>
      </text>
    );
  }
);

export default Text;
